import { TravelineCititesResponseDto } from '@/api/generated/fetch-client';

import { City } from './city';

export class CityList {
  constructor(readonly cities: City[]) {}

  public static fromDto(dto: TravelineCititesResponseDto): CityList {
    return new CityList(
      dto.cities.map(
        (city) =>
          new City(
            city.id,
            city.name,
            city.timeZone,
            city.countryCode,
            city.regionId ?? undefined,
          ),
      ),
    );
  }
}
